<template>
    <div class="co-novo-documento-signatario-telefone-signatario">

        <div class="label-telefone">
            Telefone <span v-if="campoRequerido" class="required">*</span>
        </div>

        <div class="telefone">
            <v-flex class="box-selecionar-ddi" @click="abrirDialogPais">
                <span class="texto-ddi">
                    {{ isoCode }} {{ ddiSelecionado }}
                    <v-icon size="20" color="text-color-300"> mdi-chevron-down </v-icon>
                 </span>
            </v-flex>

            <v-flex>
                <v-text-field
                    v-model="value.telefone"
                    v-mask="mascara"
                    v-validate="validarCampo()"
                    :class="campoRequerido ? 'required-field' : ''"
                    :error-messages="coletarErros(errors)"
                    autocomplete="off"
                    dense
                    outlined
                    name="Telefone"
                    placeholder="(DDD) 000000000"
                    hide-details
                />
            </v-flex>
        </div>

        <v-switch
            v-if="campoRequerido"
            v-model="value.skipFotoWpp"
            label="Solicitar autenticação por Selfie"
            :true-value="false"
            :false-value="true"/>

        <dialog-pais
            :dialog="dialogPais"
            @fechar="fecharDialogPais"
            @adicionar-ddi="adicionarDdi"
        />
    </div>
</template>

<script>
import DialogPais from '@/commons/components/dialogs/DialogPais'

export default {
    name: 'TelefoneSignatarioNovo',
    components: {DialogPais},
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        descricao: {
            type: Boolean
        },
        formScope: {
            type: String,
            required: false,
            default: null
        }
    },
    data: () => ({
        dialogPais: false,
        isoCode: 'BR +',
        ddiDefault: '55'
    }),
    computed: {
        ddiSelecionado() {
            return this.value.ddi == null ? this.ddiDefault : this.value.ddi
        },
        descricaoCampo() {
            return `Número de telefone que o ${this.$tc("pt_br.signatario").toLowerCase()} irá usar para receber as notificações`
        },
        mascara() {
            return this.ddiSelecionado == '55' ? '(##) # ####-####' : '############'
        }
    },
    methods: {
        abrirDialogPais() {
            this.dialogPais = true
        },
        adicionarDdi(item) {
            this.ddiDefault = item.fone
            this.isoCode = item.iso
            this.value.ddi = item.fone
        },
        coletarErros(e) {
            if (this.formScope !== null) {
                return e.collect('Telefone', this.formScope)
            }

            return e.collect('Telefone')
        },
        fecharDialogPais() {
            this.dialogPais = false
        },
        validarCampo() {
            return this.campoRequerido ? 'required' : ''
        }
    }
}
</script>

<style lang="stylus">
.co-novo-documento-signatario-telefone-signatario
    .label-telefone
        color var(--text-color-300)

        .required
            color var(--error-300)

    .telefone
        display flex
        align-items center

        .box-selecionar-ddi
            width 100px
            border-right 1px solid #cccccc
            cursor pointer

            .texto-ddi
                font-weight bold
                color var(--text-color-300)
</style>
